import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IGetBadgesUseCase } from '../../core/usecases/rewardSystem/GetBadgesUseCase';
import { IBadgeApiResponse, IQuestApiResponse } from '../../entity/interface/iRewardSystem';
import { IGetQuestsUseCase } from '../../core/usecases/rewardSystem/GetQuestsUseCase';

export interface IRewardService {
    getBadges(identityToken: string, apiKey: string): Promise<IBadgeApiResponse['data']>;
    getQuests(identityToken: string, apiKey: string): Promise<IQuestApiResponse['data']>;
}

export class RewardService implements IRewardService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get getBadgesUseCase(): IGetBadgesUseCase {
        return container.resolve<IGetBadgesUseCase>(DI.USECASES.IGetBadgesUseCase);
    }

    private get getQuestsUseCase(): IGetQuestsUseCase {
        return container.resolve<IGetQuestsUseCase>(DI.USECASES.IGetQuestsUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getBadges(identityToken: string, apiKey: string): Promise<IBadgeApiResponse['data']> {
        return await this.getBadgesUseCase.execute(identityToken, apiKey);
    }

    async getQuests(identityToken: string, apiKey: string): Promise<IQuestApiResponse['data']> {
        return await this.getQuestsUseCase.execute(identityToken, apiKey);
    }
}
